import { render } from "./Contact_m.vue?vue&type=template&id=75c4d13a&scoped=true"
import script from "./Contact_m.vue?vue&type=script&lang=js"
export * from "./Contact_m.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-75c4d13a"

export default script